module.exports = __webpack_public_path__ + "img/w4.10daaf87.png";